type Filter<T, U> = T extends U ? T : never;

export const onKeyDown = <T>(
  callback?: (event: React.MouseEvent<T>) => void,
  events = ["Spacebar", " ", "Enter"]
): ((event: React.KeyboardEvent<T>) => void) => {
  return (event) => {
    if (events.includes(event.key)) {
      if (callback) callback(event as Filter<React.KeyboardEvent<T>, React.MouseEvent<T>>);
    }
  };
};
